import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap"
import ComponentBackButton from "../../../../../common/AdminCommonComponents/Buttons/ComponentBackButton/ComponentBackButton"
import GrayHeading from "../../../../../common/AdminCommonComponents/GrayHeading/GrayHeading"
import DynamicButton from "../../../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"

const AddNewSellerType = ({ setAddSellerTypeFormOpen }) => {
  return (
    <div className="bg-white shadow px-4 p-3 mt-3">
      <ComponentBackButton onClick={() => setAddSellerTypeFormOpen((prev) => !prev)} />
      <div className="d-flex justify-content-center">
        <GrayHeading>Add new Seller Type</GrayHeading>
      </div>

      <Form className="mt-3" onSubmit={(e) => e.preventDefault()}>
        <Row className="row-cols-1 row-cols-md-2">
          <Col>
            <Row className="g-0">
              <Col md={12}>
                <FormGroup>
                  <Label className="fw-medium" for="sellerTypeName">
                    Seller Type Name
                  </Label>
                  <Input id="sellerTypeName" name="sellerTypeName" placeholder="" type="text" />
                </FormGroup>
              </Col>
              <Col md={12}>
                <FormGroup>
                  <Label className="fw-medium" for="additionalCommission">
                    Additional Commission
                  </Label>
                  <Input id="additionalCommission" name="additionalCommission" placeholder="" type="text" />
                </FormGroup>
              </Col>
            </Row>
          </Col>
          <Col>
            <FormGroup>
              <Label className="fw-medium" for="desc">
                Description
              </Label>
              <Input id="desc" name="desc" placeholder="" type="textarea" />
            </FormGroup>
          </Col>
        </Row>
        {/* <Row>
          <Col md={6}>
            <FormGroup>
              <Label className="fw-medium" for="sellerTypeName">Seller Type Name</Label>
              <Input id="sellerTypeName" name="sellerTypeName" placeholder="" type="text" />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label className="fw-medium" for="desc">Description</Label>
              <Input id="desc" name="desc" placeholder="" type="textarea" />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label className="fw-medium" for="additionalCommission">Additional Commission</Label>
              <Input id="additionalCommission" name="additionalCommission" placeholder="" type="text" />
            </FormGroup>
          </Col>
        </Row> */}

        <div className="d-flex justify-content-end gap-3 my-3">
          <DynamicButton theme="blue-outline">Cancel</DynamicButton>
          <DynamicButton theme="blue">Submit</DynamicButton>
        </div>
      </Form>
    </div>
  )
}

export default AddNewSellerType
